module.exports = __webpack_public_path__ + "static/expanding-a98b661387081293612ef5457a5be9ab.jpg";